import * as React from "react";
const SvgRightArrow = props => <svg width={7} height={12} viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1 1L6 6L1 11" strokeOpacity={0.61} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgRightArrow;